



import Vue from "vue";
const endpoint = process.env.VUE_APP_TWITTER_AUTH_API_ENDPOINT;

import store from "store";

export default Vue.extend({
  methods: {
    click: async function() {
      const origin = location.origin;

      const response = await fetch(`${endpoint}?cb=${origin}`);
      const json = await response.json();

      store.set('twitter_auth_info', { timestamp: Date.now() });

      location.href = json.authenticateUrl;
    }
  }
});
